export const lineItemChargeCategories = {
  fsc: 'FSC',
  lh: 'LH'
};
